import React, { PureComponent } from 'react';
import $ from 'jquery';

import { isTouchDevice } from '../project-utils';

class MobileOverlay extends PureComponent {

  state = {
    isDrawingMode: false
  }

  constructor() {
    super();

    this.hasTouchSupport = isTouchDevice();
    this.isEmbedMode = $('html').hasClass('is-embed-mode');
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.hasTouchSupport) {
      return false;
    }

    if (!prevProps.mapMounted && this.props.mapMounted) {
      this.touchfix.addEventListener('touchstart', this.onTouch('mousedown'), { passive: false });
      this.touchfix.addEventListener('touchmove', this.onTouch('mousemove'), { passive: false });
      this.touchfix.addEventListener('touchend', this.onTouchEnd, { passive: false });
    }
  }

  onTouch = (touchtype) => {
    return (evt) => {
      evt.preventDefault();

      const containerPoint = this.props.map.mouseEventToContainerPoint(evt.touches[0]);
      const layerPoint = this.props.map.containerPointToLayerPoint(containerPoint);
      const latlng = this.props.map.layerPointToLatLng(layerPoint);

      this.props.map.fire(touchtype, {
        latlng: latlng,
        layerPoint: layerPoint,
        containerPoint: containerPoint,
        originalEvent: evt
      });
    }
  }

  onTouchEnd = (evt) => {
    evt.preventDefault();

    this.props.map.fire('mouseup', {
      originalEvent: evt
    });
  }

  onDrawModeClick = () => {
    this.setState({
      isDrawingMode: true
    });
  }

  render() {
    if (!this.hasTouchSupport) {
      return null;
    }

    return [
      <div
        key="mobileoverlay"
        className="mobileoverlay"
        style={{ display: this.state.isDrawingMode ? 'none' : 'flex' }}
      >
        <button className="btn startdraw" onClick={this.onDrawModeClick}>Zeichnen starten</button>
      </div>,
      <div
        key="touchfix"
        className="touchfix"
        style={{ width: '100%', height: '100%', position: 'absolute', zIndex: 900, display: this.state.isDrawingMode && this.props.step === 'draw' ? 'block' : 'none' }}
        ref={ref => { this.touchfix = ref; }}
      />
    ];
  }
}

export default MobileOverlay;